//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SentEmailAttachmentDisplayItem } from './SentEmailAttachmentDisplayItem';
import { MessageMethod, MessageStatus } from './Enums';

export class SentMessageDisplayItem extends ItemBase {
    MessageID: string | null = null;
    MessageGroupID: string | null = null;
    MethodType: MessageMethod = MessageMethod.Email;
    Status: MessageStatus = MessageStatus.Bounced;
    DateSent: string = "1970-01-01T00:00:00";
    Subject: string | null = null;
    Body: string | null = null;
    SenderAddress: string | null = null;
    SenderName: string | null = null;
    RecipientAddress: string | null = null;
    RecipientName: string | null = null;
    HasAttachments: boolean = false;
    Attachments: SentEmailAttachmentDisplayItem[] = [];
    HandledExternally: boolean = false;

    constructor(initializer?: Partial<SentMessageDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SentMessageDisplayItem";
}
